import { Link } from "react-router-dom";

/**
 * Red outlined "Suicide and Crisis" circle that sits at the top right of the
 * header, after the search box, on every page. Stays visible on small screens
 * (never collapses into a hamburger). Network-wide treatment, mirrors
 * DepressionResource. Links to the crisis page.
 */
export default function CrisisCircle() {
  return (
    <Link
      to="/suicide-and-crisis"
      aria-label="Suicide and Crisis resources"
      className="crisis-circle"
      data-testid="crisis-circle"
    >
      <span aria-hidden="true">
        Suicide
        <br />
        and
        <br />
        Crisis
      </span>
    </Link>
  );
}
